import {DateTime} from 'luxon';
import {JustificationType, NoonPeriod} from '@model/legal-student-absence';

export interface LegalAbsenceCoveredByJustification {
  schoolYear: string;
  date: DateTime;
  period: NoonPeriod;
}

export enum LegalAbsenceJustificationStatus {
  VALIDATION_NOT_REQUIRED = 'VALIDATION_NOT_REQUIRED',
  WAITING_FOR_VALIDATION = 'WAITING_FOR_VALIDATION',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export const LEGAL_ABSENCE_JUSTIFICATION_FILE_TYPES_ACCEPTED_BY_ADMINISTRATION  = [
  'application/pdf',
  'image/jpeg',
  'image/png'
];

export interface updateJustificationStatusData {
  type?: string;
  remark?: string;
  status?: LegalAbsenceJustificationStatus;
  reason?: string;
}

export interface LegalAbsenceJustification {
  justificationId: number;
  studentId: number;
  studentFirstName: string;
  studentLastName: string;
  studentClassId?: number;
  studentClassName?: string;
  type: JustificationType;
  educatorId?: number;
  remark?: string;
  reference?: number;
  referenceByClass?: string;
  documentReferenceId?: string;
  validated: boolean;
  legalAbsences: LegalAbsenceCoveredByJustification[];
}

export interface SearchDataLegalAbsenceJustification {
  status?: LegalAbsenceJustificationStatus;
  page?: number;
  size?: number;
  sortColumn?: string[];
  sortDirection?: 'asc' | 'desc';
}

export interface JustificationToValidateRef {
  studentId: number;
  justificationId: number;
}
